import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "navigation/features",
  "use": "navigation/features-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"navigation/features\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 8.003a8 8 0 1 0 16 0 8 8 0 0 0-16 0zm14 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0zm-7-3a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2H9v2a1 1 0 1 1-2 0v-2H5a1 1 0 0 1 0-2h2v-2z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol